import './App.css';
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import NavBar from './core/Navbar';
import GeneralErrorDialog from './helper/general-error/GeneralErrorDialog';
import ConfirmationModal from './helper/confirmation-modal/ConfirmationModal';
import Login from './auth/Login'
import { Grid } from '@mui/joy';
import ClientesDashboard from './clientes/ClientesDashboard';
import EstoqueDashboard from './estoque/EstoqueDashboard';
import RelatorioDashboard from './relatorios/RelatorioDashboard';


function App() {

  var authenticated = useSelector((state) => state.auth.estaAutenticado)

  // Para uso no cdn.anano.com.br com php
  var serverBasename = typeof(window.serverBasename) != "undefined" ? window.serverBasename : "";

  return (
    <BrowserRouter basename={serverBasename}>
      {authenticated && <NavBar />}
      <GeneralErrorDialog />
      <ConfirmationModal />
      <Routes>
        <Route path="/estoque" element={
          <PrivateRoute component={() => <EstoqueDashboard />} auth={authenticated} />
        } />
        <Route path="/clientes" element={
          <PrivateRoute component={() => <ClientesDashboard />} auth={authenticated} />
        } />
        <Route path="/relatorios" element={
          <PrivateRoute component={() => <RelatorioDashboard />} auth={authenticated} />
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
      </Routes>
    </BrowserRouter>
  )
}

const PrivateRoute = ({ component: Component, auth: auth, ...rest }) => {
  if (auth) {
    return <Grid container spacing={0} sx={{padding: "10px"}}>
      <Component {...rest} />
    </Grid>
  } else {
    return <Navigate to={{
      pathname: '/login',
      state: { from: rest.location }
    }} />
  }

};

export default App;